import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ClearIcon from '@mui/icons-material/Clear';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import cardList from '../../../data/video.json';
import Banner from '../../atoms/Banner/Banner';
import CardMolecules from '../../molecules/CardMolecules';
import PagiNation from '../../molecules/PagiNation/PagiNation';
import SearchInput from '../../molecules/SearchInput/SearchInput';
const bannerData = {
  imgSrc: '/images/image/footprint@2x.png',
  imgSrcM: '/images/image/foot print m@2x.png',
  title: 'Video',
  text1: 'Introducing the outstanding performances of trainees at the Best of the Best Center.',
};

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  contents: { width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', position: 'relative' },
  searchArea: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '16px',
    marginBottom: '18px',
    position: 'relative',
    paddingTop: '16px',

    width: '1064px',
    '@media only screen and (max-width: 1100px)': {
      width: '704px',
    },

    '@media only screen and (max-width: 768px)': {
      width: '400px',
      marginRight: 0,
    },
    '@media only screen and (max-width: 460px)': {
      width: '404px',
    },
    '@media only screen and (max-width: 400px)': {
      width: '348px',
    },

    '@media only screen and (max-width: 344px)': {
      width: '325px',
    },
  },

  input: {
    width: '240px',
    borderBottom: '1px solid',
    '@media only screen and (max-width: 768px)': {
      width: '180px',
    },
    '@media only screen and (max-width: 460px)': {
      width: '150px',
    },
  },

  itemBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '@media only screen and (max-width: 340px)': {
      paddingLeft: '8px',
    },
  },

  searchIcon: {
    right: 0,

    position: 'absolute',

    '& path': {
      border: 0,
    },
  },

  imageBox: {
    position: 'absolute',
    zIndex: 100,
    top: 0,
    width: '100vw',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5) ',

    '@media only screen and (max-width: 768px)': {
      alignItems: 'center',
      marginTop: '10px',
    },
  },

  absoluteBox: {
    width: '66.6%',
    height: '100%',
    backgroundColor: 'white',
    flexDirection: 'column',
    alignItems: 'center',
    display: 'flex',
    position: 'relative',

    '@media only screen and (max-width: 768px)': {
      height: '370px',
      width: '100%',
    },
  },

  topBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  title: {
    fontWeight: '600',

    '@media only screen and (max-width: 768px)': {
      fontSize: '17px',
    },
  },

  topContents: {
    width: '75%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '60px',

    '@media only screen and (max-width: 768px)': {
      marginTop: '10px',
      width: '90%',
    },
    '@media only screen and (max-width: 425px)': {
      width: '300px',
      paddingTop: '26px',
    },
  },

  image: {
    width: '75%',
    height: '32%',
    marginTop: '24px',
    marginBottom: '24px',

    backgroundColor: 'white',
    objectFit: 'contain',
    '@media only screen and (max-width: 768px)': {
      width: '90%',
      height: '78%',
      marginTop: '16px',
    },

    '@media only screen and (max-width: 425px)': {
      width: '300px',
      height: '300px',
    },
  },

  icon: {
    cursor: 'pointer',
    width: '36px',
    fontSize: '32px !important',

    '@media only screen and (max-width: 768px)': {
      fontSize: '26px !important',
    },
  },

  handleImageBox: {
    display: 'flex',
    width: '75%',
    justifyContent: 'space-between',
    '@media only screen and (max-width: 768px)': {
      width: '90%',
    },
    '@media only screen and (max-width: 425px)': {
      width: '300px',
    },
  },

  arrowBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#5a5a5a',
    fontSize: '16px',

    '& .svg': {
      color: '#5a5a5a',
      width: '30px',
      height: '30px',
    },

    '@media only screen and (max-width: 425px)': {
      fontSize: '14px',
    },
  },
  backIcon: {
    marginRight: '8px',

    cursor: 'pointer',
    paddingBottom: '2px',
    '@media only screen and (max-width: 425px)': {
      paddingBottom: 0,
    },
  },
  forwardIcon: {
    marginLeft: '8px',

    cursor: 'pointer',
    paddingBottom: '2px',
    '@media only screen and (max-width: 425px)': {
      paddingBottom: 0,
    },
  },

  iconBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  mobileIconBox: {
    width: '90%',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'absolute',
    bottom: '40%',

    '@media only screen and (max-width: 425px)': {
      width: '300px',
      bottom: '40%',
    },
  },
  mobileArrow: {
    width: '64px',
    height: '44px',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: '0.4s',
    '&:hover': {
      backgroundColor: '#191919',
      opacity: '0.5',
    },
  },

  mobileIcon: {
    fontSize: '28px !important',
    display: 'hidden !important',
    opacity: '0.1',
    '&:hover': {
      backgroundColor: '#191919',
      color: '#f4f4f4',
      opacity: '0.5',
      display: 'flex !important',
    },
  },
  iframe: {
    width: '75%',
    height: '32%',
    marginTop: '24px',
    marginBottom: '24px',

    backgroundColor: 'white',

    '@media only screen and (max-width: 768px)': {
      width: '90%',
      height: '78%',
      marginTop: '16px',
    },

    '@media only screen and (max-width: 425px)': {
      paddingTop: '12px',
      width: '300px',
      height: '206px',
    },
  },
});
export default function VideoPage(props) {
  const { video } = props;
  const classes = useStyles();
  const [list, setList] = useState(cardList);
  const [currentPage, setCurrentPage] = useState(1);

  const [postsPerPage, setPostsPerPage] = useState(6);
  const indexOfLast = currentPage * postsPerPage;
  const indexOfFirst = indexOfLast - postsPerPage;

  const [contents, setContents] = useState('');
  const [prevImage, setPrevImage] = useState();
  const [nextImage, setNextImage] = useState();

  const [scrollWidth, setCcrollWidth] = useState();
  const [scrollHeight, setCcrollHeight] = useState();
  const [widthCheck, setWidthCheck] = useState();

  const [searchData, setSearchData] = useState('');

  const handleContents = (i, e) => {
    setContents(i);

    setCcrollWidth(e.clientX);
    setCcrollHeight(e.clientY);
    if (widthCheck === false) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(e.clientX, e.clientY);
    }
  };

  useEffect(() => {
    if (widthCheck === false) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(scrollWidth, scrollHeight);
    }
  }, [scrollWidth, scrollHeight]);

  const handleCancle = () => {
    window.scrollTo(scrollWidth, scrollHeight);
    setContents('');
  };

  useEffect(() => {
    for (let i = 0; i < cardList.length; i++) {
      if (contents.id === cardList[i].id && contents.id !== 0) {
        setPrevImage(cardList[i - 1]);
        setNextImage(cardList[i + 1]);
      } else if (contents.id === cardList[i].id && contents.id === 0) {
        setPrevImage('');
        setNextImage(cardList[i + 1]);
      } else if (contents.id === cardList[i].id && contents.id === cardList.length) {
        setPrevImage(cardList[i - 1]);
        setNextImage('');
      }
    }
  }, [contents, prevImage, nextImage]);

  const forwardArrowImage = () => {
    for (let i = 0; i < cardList.length; i++) {
      if (contents.id === cardList[i].id) {
        setContents(cardList[i - 1]);
        setPrevImage(cardList[i - 2]);
        setNextImage(cardList[i]);
      } else if (contents.id === cardList[i].id && prevImage.id === 0) {
        setPrevImage('');
        setContents(cardList[i - 1]);
        setNextImage(cardList[i]);
      }
    }
  };

  const nextArrowImage = () => {
    for (let i = 0; i < cardList.length; i++) {
      if (contents.id === cardList[i].id) {
        setContents(cardList[i + 1]);
        setPrevImage(cardList[i]);
        setNextImage(cardList[i + 2]);
      } else if (contents.id === cardList[i].id && nextImage.id === cardList.length) {
        setPrevImage(cardList[i]);
        setContents(cardList[i + 1]);
        setNextImage('');
      }
    }
  };
  function currentPosts(tmp) {
    let currentPosts = 0;
    currentPosts = tmp.slice(indexOfFirst, indexOfLast);
    return currentPosts;

    // 페이지네이션 slice 해주는 역할
  }

  const prevClick = () => {
    setCurrentPage(currentPage - 1);
  };
  const nextClick = () => {
    setCurrentPage(currentPage + 1);
  };

  const prevPageClick = () => {
    let x = Math.ceil(currentPage / 5) - 1;
    let y = x - 1;
    const z = 1;

    if (Math.ceil(currentPage / 5) === 1) {
      setCurrentPage(1);
    } else setCurrentPage(y * 5 + z);
  };

  const nextPageClick = () => {
    let x = Math.ceil(currentPage / 5) + 1;
    let y = x - 1;
    const z = 1;

    if (Math.ceil(list.length / postsPerPage / 5) === Math.ceil(currentPage / 5)) {
      return;
    } else setCurrentPage(y * 5 + z);
  };

  const searchContents = (e) => {
    let search = e.target.value;
    let array = [];
    for (let i = 0; i < cardList.length; i++) {
      if (cardList[i].title.toUpperCase().includes(search.toUpperCase())) {
        array.push(cardList[i]);
      }
    }

    setSearchData(search);
    setList(array);

    //검색해서 array 안에 새로 push 해주는 역할
  };

  const handleResize = () => {
    if (window.innerWidth > 1100) {
      setPostsPerPage(6);
    } else if (window.innerWidth < 1100 && window.innerWidth > 720) {
      setPostsPerPage(4);
    } else if (window.innerWidth < 720) {
      setPostsPerPage(3);
    }

    if (window.innerWidth > 768) {
      setWidthCheck(false);
    } else {
      setWidthCheck(true);
    }
  };

  useEffect(() => {
    if (window.innerWidth > 1100) {
      setPostsPerPage(6);
    } else if (window.innerWidth < 1100 && window.innerWidth > 720) {
      setPostsPerPage(4);
    } else if (window.innerWidth < 720) {
      setPostsPerPage(3);
    }

    if (window.innerWidth > 768) {
      setWidthCheck(false);
    } else {
      setWidthCheck(true);
    }

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };

    //처음 화면 들어왔을 때 좌표 계산해서 갯 수 표현
  }, []);

  const handleSearchIcon = () => {
    document.querySelector('#searchInput').focus();
  };
  const handleClearIcon = () => {
    setSearchData('');
    document.querySelector('#searchInput').focus();
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.contents}>
        <Banner bannerData={bannerData}></Banner>
        <Box className={classes.searchArea}>
          {/* <Input className={classes.input} onChange={searchContents}></Input>
          <SearchIcon className={classes.searchIcon}></SearchIcon> */}
          <SearchInput searchValue={searchData} handleSearch={searchContents} handleSearchIcon={handleSearchIcon} handleClearIcon={handleClearIcon} />
        </Box>
        <CardMolecules cardList={currentPosts(list)} handleContents={handleContents}></CardMolecules>
        <PagiNation
          prevClick={prevClick}
          prevPageClick={prevPageClick}
          nextClick={nextClick}
          currentNum={currentPage}
          nextPageClick={nextPageClick}
          postsPerPage={postsPerPage}
          totalPosts={list.length}
          paginate={setCurrentPage}
        ></PagiNation>

        {!!contents && contents ? (
          <Box className={classes.imageBox}>
            <Box className={classes.absoluteBox}>
              <Box className={classes.topBox}>
                <Box className={classes.topContents}>
                  <Box className={classes.title}>{contents.title}</Box>
                  <ClearIcon onClick={handleCancle} className={classes.icon}></ClearIcon>
                </Box>
              </Box>
              {video === false ? (
                <img className={classes.image} src={contents.image} alt={contents.contents}></img>
              ) : (
                <iframe
                  title='video'
                  className={classes.iframe}
                  src={contents.videoSrc}
                  frameBorder='0'
                  allowFullScreen
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                ></iframe>
              )}

              <Box className={classes.handleImageBox}>
                {widthCheck === false ? (
                  <Box className={classes.iconBox}>
                    {!!prevImage ? (
                      <Box className={classes.arrowBox}>
                        <ArrowBackIcon onClick={forwardArrowImage} className={classes.backIcon}></ArrowBackIcon>
                        {prevImage.contents}
                      </Box>
                    ) : (
                      <Box></Box>
                    )}
                    {!!nextImage ? (
                      <Box className={classes.arrowBox}>
                        {nextImage.contents}
                        <ArrowForwardIcon onClick={nextArrowImage} className={classes.forwardIcon}></ArrowForwardIcon>
                      </Box>
                    ) : (
                      <Box></Box>
                    )}
                  </Box>
                ) : (
                  <Box className={classes.mobileIconBox}>
                    {!!prevImage ? (
                      <Box className={classes.mobileArrow}>
                        <ArrowBackIcon onClick={forwardArrowImage} className={classes.mobileIcon}></ArrowBackIcon>
                      </Box>
                    ) : (
                      <Box></Box>
                    )}
                    {!!nextImage ? (
                      <Box className={classes.mobileArrow}>
                        <ArrowForwardIcon onClick={nextArrowImage} className={classes.mobileIcon}></ArrowForwardIcon>
                      </Box>
                    ) : (
                      <Box></Box>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        ) : (
          <Box></Box>
        )}
      </Box>
    </Box>
  );
}
